var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.311,
    height: 34,
    viewBox: "0 0 50.311 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_162402",
    "data-name": "Group 162402",
    transform: "translate(-1665.689 -63)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mail",
    transform: "translate(1667 74)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83196",
    "data-name": "Path 83196",
    d: "M5.3,4H31.656a3.069,3.069,0,0,1,3.3,2.75v16.5a3.069,3.069,0,0,1-3.3,2.75H5.3A3.069,3.069,0,0,1,2,23.25V6.75A3.069,3.069,0,0,1,5.3,4Z",
    transform: "translate(-2 -4)",
    fill: "none",
    stroke: "#2699fb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83197",
    "data-name": "Path 83197",
    d: "M34.951,6,18.476,13,2,6",
    transform: "translate(-2 -4)",
    fill: "none",
    stroke: "#2699fb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "message-circle",
    transform: "translate(1695 64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "message-circle-2",
    "data-name": "message-circle",
    d: "M23,12.444a9.311,9.311,0,0,1-1,4.222,9.444,9.444,0,0,1-8.444,5.222,9.311,9.311,0,0,1-4.222-1L3,23l2.111-6.333a9.311,9.311,0,0,1-1-4.222A9.444,9.444,0,0,1,9.333,4a9.311,9.311,0,0,1,4.222-1h.556A9.422,9.422,0,0,1,23,11.889Z",
    transform: "translate(-3 -3)",
    fill: "#fb4d4d",
    stroke: "#fb4d4d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.fc5e30b0e32a3496f8e45cdd086c0962.svg";
export { ForwardRef as ReactComponent };